/* eslint no-param-reassign: 0 */

import request from "@/api/request";
import _ from "lodash";
import router from "@/router";
import qs from "query-string";
import { Notification, MessageBox } from "element-ui";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

const initialState = {
  baseUrl: API_BASE_URL,
  loading: false
};

const getters = {
  baseUrl: state => state.baseUrl,
  generateUrl: (state, getters_, rootState, rootGetters) => ({
    path,
    params = {}
  }) => {
    const mergedParams = {
      token: rootGetters["auth/token"],
      ...params
    };
    return `${state.baseUrl}${path}?${qs.stringify(mergedParams)}`;
  }
};

const actions = {
  sendRequest({ state, rootGetters, dispatch }, config) {
    const token = rootGetters["auth/token"];
    const url = `${state.baseUrl}${config.url}`;

    const shouldUseAuthHeader = config.useAuth !== false && token;

    const headers = {};
    if (shouldUseAuthHeader) {
      headers.Authorization = `Token ${token}`;
    }

    const params = config.params || {}

    if (!params.company && rootGetters["auth/activeCompany"]) {
      params.company = rootGetters["auth/activeCompany"].id
    }

    return request({
      ...config,
      timeout: 10000,
      url,
      headers,
      params,
      paramsSerializer(params) {
        return qs.stringify(params, { arrayFormat: "none" });
      }
    }).catch(err => {
      const respStatus = _.get(err, "response.status");
      if (respStatus === 401) {
        dispatch("auth/logout", null, { root: true });
        router.push({ name: "login" });
        return;
      }

      if (respStatus === 403) {
        MessageBox.alert("You are not authorised to perform this action.", {
          type: "error",
          title: "Permission error"
        });
        throw err;
      }

      if (err.request && !err.response) {
        // no response received, most likely timeout error
        Notification.error({
          title: "Timeout error",
          message:
            "Please check your internet connection and refresh this page."
        });
      } else if (_.get(err, "response.status") === 500) {
        Notification.error({
          title: "Unexpected API error",
          message:
            "We have been notified about the problem, please try shortly."
        });
      }

      throw err;
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations
};
